import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	projectsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectsTitleGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	projectsTitle: {
		id: 'platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title',
		defaultMessage: 'Projects',
		description: 'Title of the breadcrumb that navigates to projects directory page',
	},
	projectsTitleGalaxia: {
		id: 'platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title-galaxia',
		defaultMessage: 'Spaces',
		description: 'Title of the breadcrumb that navigates to projects directory page',
	},
});
export default messages;
